/**
 * External-link opener — uses Capacitor's native in-app browser when
 * running inside the iOS wrapper, and falls back to `window.open` in
 * the regular web app.
 *
 * All partner booking CTAs (LiquidSpace, COVE, etc.) route through here
 * so the click experience stays inside our tabbed SFSafariViewController
 * on iOS (fast, no app-switch flash) while the web build keeps its
 * existing new-tab behavior.
 */
export async function openExternal(url) {
  if (!url) return;
  try {
    // Dynamically import so the web bundle stays tree-shakeable.
    const { Capacitor } = await import('@capacitor/core');
    if (Capacitor?.isNativePlatform?.()) {
      const { Browser } = await import('@capacitor/browser');
      await Browser.open({
        url,
        presentationStyle: 'popover',   // sheet on iPhone, popover on iPad
        toolbarColor: '#1B2340',        // navy — matches the Métier chrome
      });
      return;
    }
  } catch { /* fall through */ }
  // Web fallback: normal target=_blank behavior.
  if (typeof window !== 'undefined') {
    window.open(url, '_blank', 'noopener,noreferrer');
  }
}

export default openExternal;
